module.exports = __webpack_public_path__ + "img/11400.a19781d3.jpg";